import { render, staticRenderFns } from "./DSearchList.vue?vue&type=template&id=6253caa6&lang=pug"
import script from "./DSearchList.vue?vue&type=script&lang=js"
export * from "./DSearchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports